import { render } from "./Dataview.vue?vue&type=template&id=355004f6&ts=true"
import script from "./Dataview.vue?vue&type=script&lang=ts"
export * from "./Dataview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__